import type { GridApi, GridReadyEvent } from 'ag-grid-community';
import { useContextMenuItems } from 'components/shared/Blotter/Grid/Hooks/useContextMenuItems';
import { useGridAutoRefresh } from 'components/shared/Blotter/Grid/Hooks/useGridAutoRefresh';
import { useCallback, useState } from 'react';
import type { Category } from 'shared/middlewares/analytics/logger';

interface UseBlotterGridApiProps {
  logAnalyticName: Category;
  isRefreshable: boolean;
}

export function useBlotterGridApi({ logAnalyticName, isRefreshable }: UseBlotterGridApiProps) {
  const [gridApi, setGridApi] = useState<GridApi>();

  const onGridReady = useCallback((event: GridReadyEvent) => {
    setGridApi(event.api);
  }, []);

  const getContextMenuItems = useContextMenuItems(logAnalyticName, gridApi);

  useGridAutoRefresh(isRefreshable ? gridApi : null);

  return {
    onGridReady,
    getContextMenuItems,
  };
}
